module.exports = __webpack_public_path__ + "media/images/new-ui-images/workflow-icon-1d9eace3ea73cc593bb7e22b29bca33f.svg";